import { useGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import GlobalSearchDialog from './GlobalSearchDialog';

export default function GlobalSearchDialogWrapper() {
  const { isOpen, closeSearch } = useGlobalSearchContext();

  return (
    <GlobalSearchDialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) closeSearch();
      }}
    />
  );
}
